// Mock data for demo mode - realistic sample data for the AI Opportunity Assessment

export const mockSubmissions = [
  // Acmecorp.com submissions
  {
    submission_id: "demo-sub-001",
    opportunity_name: "Customer Service Chatbot",
    opportunity_description: "Implement an AI-powered chatbot to provide 24/7 automated customer support, reducing response times and improving customer satisfaction while lowering support costs.",
    email: "sarah.johnson@acmecorp.com",
    domain_name: "acmecorp.com",
    tech_feasibility_score: 85,
    roi_potential_score: 78,
    strategic_value_score: 82,
    strategic_category: "Quick Wins",
    submitted_at: "2024-03-15T10:30:00Z",
    status: "completed"
  },
  {
    submission_id: "demo-sub-007",
    opportunity_name: "Email Classification System",
    opportunity_description: "Automated email routing and categorization using NLP to improve response times and reduce manual sorting workload.",
    email: "john.doe@acmecorp.com",
    domain_name: "acmecorp.com",
    tech_feasibility_score: 90,
    roi_potential_score: 65,
    strategic_value_score: 75,
    strategic_category: "Technical Experiments",
    submitted_at: "2024-03-08T14:30:00Z",
    status: "completed"
  },
  {
    submission_id: "demo-sub-008",
    opportunity_name: "Fraud Detection AI",
    opportunity_description: "Real-time fraud detection system using machine learning to identify suspicious transactions and reduce financial losses.",
    email: "jane.smith@acmecorp.com",
    domain_name: "acmecorp.com",
    tech_feasibility_score: 55,
    roi_potential_score: 95,
    strategic_value_score: 85,
    strategic_category: "Strategic Challenges",
    submitted_at: "2024-03-05T10:15:00Z",
    status: "completed"
  },
  // Techmanufacturing.com submissions
  {
    submission_id: "demo-sub-002",
    opportunity_name: "Predictive Maintenance System",
    opportunity_description: "Deploy ML models to predict equipment failures before they occur, enabling proactive maintenance scheduling and reducing costly downtime across manufacturing operations.",
    email: "mike.chen@techmanufacturing.com",
    domain_name: "techmanufacturing.com",
    tech_feasibility_score: 45,
    roi_potential_score: 88,
    strategic_value_score: 72,
    strategic_category: "Strategic Challenges",
    submitted_at: "2024-03-14T14:20:00Z",
    status: "completed"
  },
  {
    submission_id: "demo-sub-006",
    opportunity_name: "Quality Inspection Vision AI",
    opportunity_description: "Deploy computer vision systems for automated quality control and defect detection in manufacturing, improving product quality while reducing inspection time and costs.",
    email: "david.wong@techmanufacturing.com",
    domain_name: "techmanufacturing.com",
    tech_feasibility_score: 75,
    roi_potential_score: 80,
    strategic_value_score: 78,
    strategic_category: "Quick Wins",
    submitted_at: "2024-03-10T13:20:00Z",
    status: "completed"
  },
  {
    submission_id: "demo-sub-009",
    opportunity_name: "Supply Chain Optimization",
    opportunity_description: "AI-driven supply chain forecasting and optimization to reduce inventory costs and improve delivery times.",
    email: "lisa.park@techmanufacturing.com",
    domain_name: "techmanufacturing.com",
    tech_feasibility_score: 70,
    roi_potential_score: 77,
    strategic_value_score: 80,
    strategic_category: "Quick Wins",
    submitted_at: "2024-03-07T09:45:00Z",
    status: "completed"
  },
  // Financeplus.com submissions
  {
    submission_id: "demo-sub-003",
    opportunity_name: "Document Processing Automation",
    opportunity_description: "Leverage AI for intelligent document extraction, classification, and data entry automation to streamline back-office operations and reduce manual processing errors.",
    email: "jennifer.lee@financeplus.com",
    domain_name: "financeplus.com",
    tech_feasibility_score: 92,
    roi_potential_score: 52,
    strategic_value_score: 68,
    strategic_category: "Technical Experiments",
    submitted_at: "2024-03-13T09:15:00Z",
    status: "completed"
  },
  {
    submission_id: "demo-sub-010",
    opportunity_name: "Credit Risk Assessment AI",
    opportunity_description: "Machine learning models for automated credit risk evaluation and loan approval recommendations.",
    email: "michael.brown@financeplus.com",
    domain_name: "financeplus.com",
    tech_feasibility_score: 82,
    roi_potential_score: 88,
    strategic_value_score: 92,
    strategic_category: "Quick Wins",
    submitted_at: "2024-03-06T11:20:00Z",
    status: "completed"
  },
  // Retailco.com submissions
  {
    submission_id: "demo-sub-004",
    opportunity_name: "Sales Forecasting AI",
    opportunity_description: "Build predictive analytics models for sales pipeline forecasting to improve revenue planning accuracy and enable data-driven decision making for sales teams.",
    email: "robert.smith@retailco.com",
    domain_name: "retailco.com",
    tech_feasibility_score: 38,
    roi_potential_score: 42,
    strategic_value_score: 55,
    strategic_category: "Lower Priority",
    submitted_at: "2024-03-12T16:45:00Z",
    status: "completed"
  },
  {
    submission_id: "demo-sub-005",
    opportunity_name: "Inventory Optimization AI",
    opportunity_description: "Implement smart inventory management using demand forecasting and optimization algorithms to reduce carrying costs while preventing stockouts and improving order fulfillment.",
    email: "amanda.garcia@retailco.com",
    domain_name: "retailco.com",
    tech_feasibility_score: 88,
    roi_potential_score: 85,
    strategic_value_score: 90,
    strategic_category: "Quick Wins",
    submitted_at: "2024-03-11T11:30:00Z",
    status: "completed"
  },
  {
    submission_id: "demo-sub-011",
    opportunity_name: "Customer Churn Prediction",
    opportunity_description: "Predictive models to identify at-risk customers and enable proactive retention strategies.",
    email: "karen.wilson@retailco.com",
    domain_name: "retailco.com",
    tech_feasibility_score: 65,
    roi_potential_score: 72,
    strategic_value_score: 70,
    strategic_category: "Quick Wins",
    submitted_at: "2024-03-04T14:15:00Z",
    status: "completed"
  }
];

export const mockResultsData = {
  submission_id: "demo-sub-001",
  opportunity_name: "Customer Service Chatbot",
  opportunity_description: "AI-powered chatbot for 24/7 customer support",
  email: "sarah.johnson@acmecorp.com",
  domain_name: "acmecorp.com",
  tech_feasibility_score: 85,
  roi_potential_score: 78,
  strategic_value_score: 82,
  strategic_category: "Quick Wins",
  submitted_at: "2024-03-15T10:30:00Z",
  chart_data: {
    tech_feasibility_score: 85,
    roi_potential_score: 78,
    strategic_value_score: 82
  }
};

export const mockCompanyResults = {
  domain_name: "acmecorp.com",
  company_name: "Acme Corporation",
  total_submissions: 3,
  submissions: [
    {
      submission_id: "demo-sub-001",
      opportunity_name: "Customer Service Chatbot",
      tech_feasibility_score: 85,
      roi_potential_score: 78,
      strategic_value_score: 82,
      strategic_category: "Quick Wins",
      submitted_at: "2024-03-15T10:30:00Z"
    },
    {
      submission_id: "demo-sub-007",
      opportunity_name: "Email Classification System",
      tech_feasibility_score: 90,
      roi_potential_score: 65,
      strategic_value_score: 75,
      strategic_category: "Technical Experiments",
      submitted_at: "2024-03-08T14:30:00Z"
    },
    {
      submission_id: "demo-sub-008",
      opportunity_name: "Fraud Detection AI",
      tech_feasibility_score: 55,
      roi_potential_score: 95,
      strategic_value_score: 85,
      strategic_category: "Strategic Challenges",
      submitted_at: "2024-03-05T10:15:00Z"
    }
  ]
};

export const mockAnalytics = {
  total_submissions: 11,
  average_scores: {
    tech_feasibility: 72.4,
    roi_potential: 73.6,
    strategic_value: 76.5
  },
  category_distribution: {
    "Quick Wins": 6,
    "Strategic Challenges": 2,
    "Technical Experiments": 2,
    "Lower Priority": 1
  },
  submissions_by_date: [
    { date: "2024-03-04", count: 1 },
    { date: "2024-03-05", count: 1 },
    { date: "2024-03-06", count: 1 },
    { date: "2024-03-07", count: 1 },
    { date: "2024-03-08", count: 1 },
    { date: "2024-03-10", count: 1 },
    { date: "2024-03-11", count: 1 },
    { date: "2024-03-12", count: 1 },
    { date: "2024-03-13", count: 1 },
    { date: "2024-03-14", count: 1 },
    { date: "2024-03-15", count: 1 }
  ]
};

export const mockCompanies = [
  {
    domain_name: "acmecorp.com",
    submission_count: 3,
    latest_submission: "2024-03-15T10:30:00Z"
  },
  {
    domain_name: "techmanufacturing.com",
    submission_count: 3,
    latest_submission: "2024-03-14T14:20:00Z"
  },
  {
    domain_name: "financeplus.com",
    submission_count: 2,
    latest_submission: "2024-03-13T09:15:00Z"
  },
  {
    domain_name: "retailco.com",
    submission_count: 3,
    latest_submission: "2024-03-12T16:45:00Z"
  }
];

export const mockDomainEmails = {
  "acmecorp.com": [
    "sarah.johnson@acmecorp.com",
    "john.doe@acmecorp.com",
    "jane.smith@acmecorp.com"
  ],
  "techmanufacturing.com": [
    "mike.chen@techmanufacturing.com",
    "david.wong@techmanufacturing.com",
    "lisa.park@techmanufacturing.com"
  ],
  "financeplus.com": [
    "jennifer.lee@financeplus.com",
    "michael.brown@financeplus.com"
  ],
  "retailco.com": [
    "robert.smith@retailco.com",
    "amanda.garcia@retailco.com",
    "karen.wilson@retailco.com"
  ]
};

// Chart data for specific submission
export const mockChartData = {
  labels: ['Technical Feasibility', 'ROI Potential', 'Strategic Value'],
  datasets: [{
    label: 'Scores',
    data: [85, 78, 82],
    backgroundColor: [
      'rgba(54, 162, 235, 0.6)',
      'rgba(75, 192, 192, 0.6)',
      'rgba(153, 102, 255, 0.6)'
    ],
    borderColor: [
      'rgba(54, 162, 235, 1)',
      'rgba(75, 192, 192, 1)',
      'rgba(153, 102, 255, 1)'
    ],
    borderWidth: 2
  }]
};

// Portfolio chart data for admin dashboard
export const mockPortfolioChart = {
  categorized_data: {
    "Quick Wins": [
      {
        submission_id: "demo-sub-001",
        opportunity_name: "Customer Service Chatbot",
        opportunity_description: "Implement an AI-powered chatbot to provide 24/7 automated customer support, reducing response times and improving customer satisfaction while lowering support costs.",
        x: 5.6,  // ROI 78 normalized: (78-50)/5 = 5.6
        y: 7.0,  // Tech 85 normalized: (85-50)/5 = 7.0
        r: 16.4,  // Bubble size based on Strategic Value (82/5)
        tech_feasibility_score: 85,
        roi_potential_score: 78,
        strategic_value_score: 82,
        strategic_category: "Quick Wins",
        domain_name: "acmecorp.com"
      },
      {
        submission_id: "demo-sub-005",
        opportunity_name: "Inventory Optimization AI",
        opportunity_description: "Implement smart inventory management using demand forecasting and optimization algorithms to reduce carrying costs while preventing stockouts and improving order fulfillment.",
        x: 7.0,  // ROI 85 normalized: (85-50)/5 = 7.0
        y: 7.6,  // Tech 88 normalized: (88-50)/5 = 7.6
        r: 18,  // Strategic value 90
        tech_feasibility_score: 88,
        roi_potential_score: 85,
        strategic_value_score: 90,
        strategic_category: "Quick Wins",
        domain_name: "retailco.com"
      },
      {
        submission_id: "demo-sub-006",
        opportunity_name: "Quality Inspection Vision AI",
        opportunity_description: "Deploy computer vision systems for automated quality control and defect detection in manufacturing, improving product quality while reducing inspection time and costs.",
        x: 6.0,  // ROI 80 normalized: (80-50)/5 = 6.0
        y: 5.0,  // Tech 75 normalized: (75-50)/5 = 5.0
        r: 15.6,  // Strategic value 78
        tech_feasibility_score: 75,
        roi_potential_score: 80,
        strategic_value_score: 78,
        strategic_category: "Quick Wins",
        domain_name: "techmanufacturing.com"
      },
      {
        submission_id: "demo-sub-009",
        opportunity_name: "Supply Chain Optimization",
        opportunity_description: "AI-driven supply chain forecasting and optimization to reduce inventory costs and improve delivery times.",
        x: 5.4,  // ROI 77 normalized: (77-50)/5 = 5.4
        y: 4.0,  // Tech 70 normalized: (70-50)/5 = 4.0
        r: 16,  // Strategic value 80
        tech_feasibility_score: 70,
        roi_potential_score: 77,
        strategic_value_score: 80,
        strategic_category: "Quick Wins",
        domain_name: "techmanufacturing.com"
      },
      {
        submission_id: "demo-sub-010",
        opportunity_name: "Credit Risk Assessment AI",
        opportunity_description: "Machine learning models for automated credit risk evaluation and loan approval recommendations.",
        x: 7.6,  // ROI 88 normalized: (88-50)/5 = 7.6
        y: 6.4,  // Tech 82 normalized: (82-50)/5 = 6.4
        r: 18.4,  // Strategic value 92
        tech_feasibility_score: 82,
        roi_potential_score: 88,
        strategic_value_score: 92,
        strategic_category: "Quick Wins",
        domain_name: "financeplus.com"
      },
      {
        submission_id: "demo-sub-011",
        opportunity_name: "Customer Churn Prediction",
        opportunity_description: "Predictive models to identify at-risk customers and enable proactive retention strategies.",
        x: 4.4,  // ROI 72 normalized: (72-50)/5 = 4.4
        y: 3.0,  // Tech 65 normalized: (65-50)/5 = 3.0
        r: 14,  // Strategic value 70
        tech_feasibility_score: 65,
        roi_potential_score: 72,
        strategic_value_score: 70,
        strategic_category: "Quick Wins",
        domain_name: "retailco.com"
      }
    ],
    "Strategic Challenges": [
      {
        submission_id: "demo-sub-002",
        opportunity_name: "Predictive Maintenance System",
        opportunity_description: "Deploy ML models to predict equipment failures before they occur, enabling proactive maintenance scheduling and reducing costly downtime across manufacturing operations.",
        x: 7.6,  // ROI 88 normalized: (88-50)/5 = 7.6
        y: -1.0,  // Tech 45 normalized: (45-50)/5 = -1.0
        r: 14.4,  // Strategic value 72
        tech_feasibility_score: 45,
        roi_potential_score: 88,
        strategic_value_score: 72,
        strategic_category: "Strategic Challenges",
        domain_name: "techmanufacturing.com"
      },
      {
        submission_id: "demo-sub-008",
        opportunity_name: "Fraud Detection AI",
        opportunity_description: "Real-time fraud detection system using machine learning to identify suspicious transactions and reduce financial losses.",
        x: 9.0,  // ROI 95 normalized: (95-50)/5 = 9.0
        y: 1.0,  // Tech 55 normalized: (55-50)/5 = 1.0
        r: 17,  // Strategic value 85
        tech_feasibility_score: 55,
        roi_potential_score: 95,
        strategic_value_score: 85,
        strategic_category: "Strategic Challenges",
        domain_name: "acmecorp.com"
      }
    ],
    "Technical Experiments": [
      {
        submission_id: "demo-sub-003",
        opportunity_name: "Document Processing Automation",
        opportunity_description: "Leverage AI for intelligent document extraction, classification, and data entry automation to streamline back-office operations and reduce manual processing errors.",
        x: 0.4,  // ROI 52 normalized: (52-50)/5 = 0.4
        y: 8.4,  // Tech 92 normalized: (92-50)/5 = 8.4
        r: 13.6,  // Strategic value 68
        tech_feasibility_score: 92,
        roi_potential_score: 52,
        strategic_value_score: 68,
        strategic_category: "Technical Experiments",
        domain_name: "financeplus.com"
      },
      {
        submission_id: "demo-sub-007",
        opportunity_name: "Email Classification System",
        opportunity_description: "Automated email routing and categorization using NLP to improve response times and reduce manual sorting workload.",
        x: 3.0,  // ROI 65 normalized: (65-50)/5 = 3.0
        y: 8.0,  // Tech 90 normalized: (90-50)/5 = 8.0
        r: 15,  // Strategic value 75
        tech_feasibility_score: 90,
        roi_potential_score: 65,
        strategic_value_score: 75,
        strategic_category: "Technical Experiments",
        domain_name: "acmecorp.com"
      }
    ],
    "Lower Priority": [
      {
        submission_id: "demo-sub-004",
        opportunity_name: "Sales Forecasting AI",
        opportunity_description: "Build predictive analytics models for sales pipeline forecasting to improve revenue planning accuracy and enable data-driven decision making for sales teams.",
        x: -1.6,  // ROI 42 normalized: (42-50)/5 = -1.6
        y: -2.4,  // Tech 38 normalized: (38-50)/5 = -2.4
        r: 11,  // Strategic value 55
        tech_feasibility_score: 38,
        roi_potential_score: 42,
        strategic_value_score: 55,
        strategic_category: "Lower Priority",
        domain_name: "retailco.com"
      }
    ]
  },
  colors: {
    "Quick Wins": "#36b37e",
    "Strategic Challenges": "#ff5630",
    "Technical Experiments": "#0065ff",
    "Lower Priority": "#6b778c"
  },
  median_tech: 80,
  median_roi: 79
};
